/**
 * モーダルの処理
 */

export default class Modal {
  constructor() {
    this.modal = document.querySelector('#modal');
    this.modalOverlay = document.querySelector('#modal__overlay');
    this.openButton = document.querySelector('#modal-open');
    this.closeButton = document.querySelector('#modal-close');
    if (!this.modal || !this.modalOverlay || !this.openButton || !this.closeButton) return;
    this.init();
  }

  // モーダルを表示
  modalOpen() {
    this.modal.classList.add('is-show');
    document.body.style.overflow = 'hidden'; // メインページのスクロールを無効にする
  }

  // モーダルを閉じる
  modalClose() {
    this.modal.classList.remove('is-show');
    document.body.style.overflow = ''; // メインページのスクロールを元に戻す
  }

  // イベント付与
  addEvent() {
    // ボタンクリックでモーダルを表示
    this.openButton.addEventListener('click', () => {
      this.modalOpen();
    });
    // ボタンクリックでモーダルを非表示
    this.closeButton.addEventListener('click', () => {
      this.modalClose();
    });
    // モーダルの背景をクリックで、モーダルを非表示
    this.modalOverlay.addEventListener('click', (e) => {
      if (e.target === this.modalOverlay) {
        this.modal.classList.remove('is-show');
        document.body.style.overflow = ''; // メインページのスクロールを元に戻す
      }
    });
  }

  init() {
    this.addEvent();
  }
}
